import { render, staticRenderFns } from "./ComposeMessage.vue?vue&type=template&id=2c0431e9&"
import script from "./ComposeMessage.vue?vue&type=script&lang=js&"
export * from "./ComposeMessage.vue?vue&type=script&lang=js&"
import style0 from "./ComposeMessage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports